<script setup lang="ts">
import { computed } from "vue";
import { defineProps } from "vue";

import { Bar } from "vue-chartjs";
import { Chart as ChartJS } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Title } from "chart.js";
import { Legend } from "chart.js";
import { Tooltip } from "chart.js";
import { BarElement } from "chart.js";
import { LinearScale } from "chart.js";
import { CategoryScale } from "chart.js";

const props = defineProps<{
  indexAxis?: string;
  barThickness?: number;
  scales: {
    y?: {
      min: number;
      max: number;
    };
    x?: {
      min: number;
      max: number;
    };
  };
  data: {
    labels: string[];
    datasets: {
      data: number[];
      backgroundColor: string[];
    }[];
  };
  options?: Record<string, any>;
}>();

const defaultOptions = {
  responsive: true,
  indexAxis: "x",
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  title: {
    display: false,
  },
  barThickness: 160,
};

const scales = computed(() => {
  const indexAxis = props.indexAxis ?? defaultOptions.indexAxis;
  let y = {
    ticks: {
      stepSize: 25,
      color: "#272740",
      font: {
        size: 12,
      },
    },
    grid: {
      drawOnChartArea: indexAxis !== "y",
    },
  };
  if (indexAxis === "x") {
    y.min = props.scales.y.min;
    y.max = props.scales.y.max;
    y.ticks.callback = (value) => {
      return [0, 50, 100].includes(value) ? value : "";
    };
  }

  const x = {
    ticks: {
      stepSize: 25,
      color: "#272740",
      font: {
        size: 12,
      },
    },
    grid: {
      drawOnChartArea: indexAxis !== "x",
    },
  };
  if (indexAxis === "y") {
    x.min = props.scales.x?.min;
    x.max = props.scales.x?.max;
    x.ticks.callback = (value) => {
      return [-100, 0, 100].includes(value) ? value : "";
    };
  }

  return { x, y };
});

const options = {
  ...defaultOptions,
  barThickness: props.barThickness ?? defaultOptions.barThickness,
  indexAxis: props.indexAxis,
  scales: scales.value,
  ...(props.options ? props.options : {}),
};

ChartJS.register(
  Title,
  Legend,
  Tooltip,
  BarElement,
  LinearScale,
  CategoryScale,
  ChartDataLabels,
);
</script>

<template>
  <div class="vi-chart">
    <Bar :chart-data="props.data" :chart-options="options" />
  </div>
</template>
